import React  from 'react';

import daotu21 from '../assets/img/daotu21.jpg';
import daotu22 from '../assets/img/daotu22.jpg';

const Enclosure21 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div>
            <img src={daotu21} alt="" style={{
                width  : '100%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <img src={daotu22} alt="" style={{
                width  : '100%',
                display: 'block',
                margin : '0 auto'
            }}/>
            
            <br/><br/>
        </div>
    </div>



export default Enclosure21;